import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TextInputLoading from "@/components/formBuilder/components/textInput/sections/loading";
import InputHolder from "@/components/formBuilder/components/inputHolder";
import SelectInputComponent from "@/components/formBuilder/components/selectInput/sections/component";
import { getTitle as defaultGetTitle } from "@/utils/generators/data";
export default function SelectInput(param) {
    let { getTitle = defaultGetTitle, placeholder, fixed, path, required, label, disabled, watchingPaths, moreOnChange, defaultValue, options, onlyKey, inputClassName, menuClassName, searchable, clearable, className, inputProps, readOnly, useOffset } = param;
    return /*#__PURE__*/ _jsxs(InputHolder, {
        watchingPaths: watchingPaths,
        disabled: disabled,
        options: options,
        children: [
            /*#__PURE__*/ _jsx(SelectInputComponent, {
                placeholder: placeholder,
                useOffset: useOffset,
                getTitle: getTitle,
                onlyKey: onlyKey,
                inputClassName: inputClassName,
                menuClassName: menuClassName,
                searchable: searchable,
                clearable: clearable,
                className: className,
                inputProps: inputProps,
                readOnly: readOnly,
                moreOnChange: moreOnChange,
                defaultValue: defaultValue,
                label: label,
                path: path,
                fixed: fixed,
                required: required
            }),
            /*#__PURE__*/ _jsx(TextInputLoading, {
                path: path
            })
        ]
    });
}
